import React, { useState } from "react";
import styled from "styled-components";

import { BhHomepage10View } from "./BhHomePage10View";

const StyledElement = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  padding: 0px 162px;
  width: 100%;
  height: 1200px;

& .header-container {
    position: absolute;
    top: 215px;
    height: 100px;
}  

& .img-header-item {
  width: 400px;
  height: 100px;
cursor: pointer;}

& .item-container {
    position: absolute;
    top: 355px;
}

`;


export const BhHomepage10 = () => {
    const [activeImageIndex, setActiveImageIndex] = useState(0); // 기본값으로 첫 번째 이미지가 다운된 상태

    // 이미지 URL을 동적으로 설정
    const imageNames = Array.from({ length: 3 }, (_, index) => `/image/10page_h_${index + 1}_up.png`);
    const selectedImageNames = Array.from({ length: 3 }, (_, index) => `/image/10page_h_${index + 1}_dn.png`);

    // 이미지 클릭 핸들러
    const handleImageClick = (index) => {
        setActiveImageIndex(index); // 클릭한 이미지의 index를 active로 설정
    };

    const renderActiveView = () => {
        switch (activeImageIndex) {
          case 1:
            return <BhHomepage10View viewNumber={1} imgLength={6}/>;
          case 2:
            return <BhHomepage10View viewNumber={2} imgLength={5}/>;
          case 3:
            return <BhHomepage10View viewNumber={3} imgLength={6}/>;
          default:
            return <BhHomepage10View viewNumber={1} imgLength={6}/>;
        }
      };

    return (
        <StyledElement>
            <img
                className="background-image"
                alt="background-image"
                src="/image/10page.png"
            />
            <div className="header-container">
                {imageNames.map((url, index) => {
                    // 현재 index와 activeImageIndex에 따라 src URL을 결정
                    const src = activeImageIndex === 0
                        ? (index === 0 ? selectedImageNames[0] : url) // 첫 번째 이미지는 기본으로 다운된 상태
                        : (activeImageIndex === index + 1 ? selectedImageNames[index] : url); // 클릭한 이미지만 다운된 상태

                    return (
                        <img
                            key={index}
                            src={src}
                            alt={`header-image-${index}`}
                            className="img-header-item"
                            onClick={() => handleImageClick(index + 1)} // 클릭 시 해당 인덱스로 업데이트
                        />
                    );
                })}
            </div>
            <div className="item-container">
                {renderActiveView()} {/* 조건에 맞는 View를 렌더링 */}
            </div>
        </StyledElement>
    );
};
